import React, { useEffect } from "react";
import BackendLayout from "../../layouts/BackendLayout";
import { PageTitle } from "../../components/admin";
import { APPROVAL_SETTING_MASTER_EXPORT } from "../../constants/routes";
import { getRouteBreadcrumb } from "../../services/BreadcrumbServices";
import { useDocumentTitle } from "../../hooks";
import { useDispatch } from "react-redux";
import { getApprovalSettingExportPage } from "../../api/setting/pageApi";
import { setPageSettings } from "../../store/actions/pageActions";
import FileExport from "../../components/file-management/FileExport";
import { API_APPROVAL_SETTING_EXPORT } from "../../constants/api";
import {ButtonExport, RedirectAlert} from "../../components";
import { clearPageLoading, setPageLoading } from "../../store/actions";
import {APPROVAL_SETTING_MASTER_EXPORT_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";

export default function ApprovalSettingExportPage() {
  useRedirectPage(APPROVAL_SETTING_MASTER_EXPORT_PAGE);
  useDocumentTitle("承認設定マスタエクスポート - 点検王");
  const breadcrumb = getRouteBreadcrumb(APPROVAL_SETTING_MASTER_EXPORT);
  const dispatch = useDispatch();

  const setApprovalSettingExportPageSettings = async (e) => {
    dispatch(setPageLoading());
    const pageSettings = await getApprovalSettingExportPage();
    dispatch(setPageSettings(pageSettings));
    dispatch(clearPageLoading());
  };

  useEffect(() => {
    setApprovalSettingExportPageSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BackendLayout breadcrumb={breadcrumb}>
      <PageTitle title="承認設定マスタエクスポート" />
      <RedirectAlert />
      <FileExport
        title="現在の承認設定マスタの状態をファイル出力します"
        description="承認設定データをExcelファイルとしてエクスポートするために、以下のボタンを押してください。"
      >
        <ButtonExport
          buttonColor="yellow"
          iconColor="616161"
          description="全ての承認設定を含む"
          borderColor="tenken__border-gray-500"
          descriptionTextColor="text-tenken-gray-900"
          titleTextColor="text-tenken-gray-700"
          apiUrl={API_APPROVAL_SETTING_EXPORT}
          id="button__export-approval-settings"
        />
      </FileExport>
    </BackendLayout>
  );
}
